import React from "react";

export default () => (
  <footer className="footer mt-2">
    <div className="container" />
  </footer>
);



// WEBPACK FOOTER //
// ./src/components/util/Footer.js